import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { PUBLIC_NAV } from '../../constants/navigation.js';
import MegaMenu from './MegaMenu.jsx';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="border-b border-white/10 bg-brand-600 text-white">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 lg:gap-6">
        <MegaMenu />

        {/* Desktop nav */}
        <ul className="hidden flex-1 flex-wrap gap-x-6 gap-y-2 py-3 text-sm lg:flex">
          {PUBLIC_NAV.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  isActive
                    ? 'font-semibold text-brand-orange'
                    : 'text-slate-200 hover:text-white'
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Mobile toggle */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="primary-nav"
          className="ml-auto inline-flex items-center gap-2 rounded p-2 text-sm text-slate-200 hover:bg-brand-500 lg:hidden"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
            {open ? (
              <path d="M6 6l12 12M6 18L18 6" strokeLinecap="round" />
            ) : (
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
            )}
          </svg>
          <span className="sr-only">Toggle menu</span>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <ul
          id="primary-nav"
          className="space-y-1 border-t border-white/10 px-4 py-3 text-sm lg:hidden"
        >
          {PUBLIC_NAV.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block rounded px-2 py-2 ${
                    isActive
                      ? 'bg-brand-500 font-semibold text-brand-orange'
                      : 'text-slate-200 hover:bg-brand-500'
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}
